import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class UserEditService {

	private apiUrl = globalConst.baseAPI;  // URL para web api

	/**
	* Método construtor
	* @param http: Http
	*/
	constructor(private http: Http) { }

	getUserDetails(token, idUser) {
		return this.http
			.get(this.apiUrl + "users/v1/getcoduser/" + idUser, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getOtherGroups(token) {
		return this.http
			.get(this.apiUrl + "groups/v1/getgroups/?$filter=Ativo eq true&$orderby=Nome asc", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getProcessesByUserID(token, id) {
		return this.http
			.get(this.apiUrl + "users/v1/getcoduser/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	searchUsers(userName, token) {
		var params = {
			Usuario: userName
		};

		return this.http
			.post(this.apiUrl + "/users/v1/getuser/?$filter=startswith(tolower(Nome),tolower('" + userName + "'))&$orderby=Nome asc", params, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	saveUser(token, objUser) {
		return this.http
			.put(this.apiUrl + "users/v1/updateuser", objUser, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	editUserStructure(token, obj) {
		return this.http
			.put(this.apiUrl + "users/v1/updateuserstruct", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	insertVacation(token, data) {
		return this.http
			.post(this.apiUrl + "vacation/v1/insertvacation", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getVacations(token, id) {
		return this.http
			.get(this.apiUrl + "vacation/v1/getcodvacationuser/" + id + "?$orderby=FeriasInicio asc", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	removeVacation(token, id) {
		return this.http
			.delete(this.apiUrl + "vacation/v1/inactivevacation/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getCommercialstructure(token, id) {
		return this.http
			.get(this.apiUrl + "commercialstructure/v1/getcommercialstructurebypapel/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getCommercialStructurePaper(token) {
		return this.http
			.get(this.apiUrl + "commercialstructurepaper/v1/commercialstructurespaper/", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getRepresentative(token) {
		return this.http
			.get(this.apiUrl + "representative/v1/getrepresentative/?$filter=Ativo eq true&$orderby=Nome asc", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

}



// WEBPACK FOOTER //
// ./src/app/user/service/user-edit/user-edit.service.ts